import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHBodyLocations from "./Components/BodyLocations";

class CHLocations extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHBodyLocations />
        <Footer />
      </>
    );
  }
}

export default CHLocations;
